// Auto-generated normalizer for table: Atributo_Usuario
export function atributoUsuarioNormalize(row) {
  return {
    idUsuarioAtributo: row.idUsuarioAtributo ?? row.IdUsuarioAtributo ?? row['IdUsuarioAtributo'] ?? 0,
    idUsuario: row.idUsuario ?? row.IdUsuario ?? row['IdUsuario'] ?? 0,
    idAtributo: row.idAtributo ?? row.IdAtributo ?? row['IdAtributo'] ?? 0,
    valorAtributo: row.valorAtributo ?? row.ValorAtributo ?? row['ValorAtributo'] ?? '',
    fechaAsignacion: row.fechaAsignacion ?? row.FechaAsignacion ?? row['FechaAsignacion'] ?? null,
  };
}
